import { View } from "react-native";
import {
  MaxesView,
  resolveTheme,
  useCatalogItems,
} from "@heraion/ui";
import { exerciseCatalog } from "./logger/exercisesCache";
import { confirmViaWindow } from "./confirm";
import { writeMax } from "./writeMax";
import { useThemePalette } from "./theme";
import { ProfileLoadState } from "./ProfileLoadState";
import { useProfileUnitOrNull } from "./ThemeProfileBridge";
import { useMaxesDataWeb } from "./maxes/useMaxesDataWeb";

// THE Maxes surface on web-rnw — the SAME shared MaxesView mobile's
// Settings → Maxes screen mounts (search + list of P1RM-capable exercises
// + the edit sheet → PUT/DELETE). Web seams: the catalog comes from the
// shared useCatalogItems over the localStorage catalog source,
// the live MAX map from useMaxesData (mobile wraps the same hook in a
// Context for its post-save bump pill; web calls it directly), and the
// destructive-clear confirm via the host-wide web seam (./confirm — RN Alert is
// a no-op on web), shared with Measurements and the coach target editor rather
// than re-implemented here. No native chrome — AppShell's tab supplies the title.

export function MaxesScreen() {
  const { dark, family } = useThemePalette();
  const theme = resolveTheme(dark, family);
  const catalog = useCatalogItems({ catalog: exerciseCatalog });
  const { maxes, status: maxesStatus, error: maxesError, forceRefresh } = useMaxesDataWeb();
  // The list renders in the athlete's unit and the edit sheet opens in it.
  const units = useProfileUnitOrNull();

  // A kg guess would seed the sheet (MX-6); a failed read says so, with its retry.
  if (units === null) return <ProfileLoadState theme={theme} />;
  return (
    <View style={{ flex: 1, backgroundColor: theme.palette.bg }}>
      <MaxesView
        theme={theme}
        catalog={catalog.raw}
        catalogError={null}
        maxes={maxes}
        maxesStatus={maxesStatus}
        maxesError={maxesError}
        units={units}
        writeMax={writeMax}
        forceRefresh={forceRefresh}
        confirm={confirmViaWindow}
      />
    </View>
  );
}
